import React from 'react';
import { useNavigate } from 'react-router-dom';
import type { AppTheme } from '@/theme/index';
import { MenuItem, type MenuItemVariation } from '../MenuItem';

interface LoginProps {
  isOpen: boolean;
  theme: AppTheme;
}

export const Login: React.FC<LoginProps> = ({ isOpen, theme }) => {
  const variation: MenuItemVariation = 'settings';
  const navigate = useNavigate();

  const handleLogin = () => {
    navigate('/login');
  };

  return (
    <MenuItem
      icon="/icons/IconLog-out.svg"
      label="Log in"
      isOpen={isOpen}
      theme={theme}
      variation={variation}
      onClick={handleLogin}
    />
  );
};
